"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHasMounted = void 0;
var _react = require("react");
var _cdsCommon = require("@cbhq/cds-common");
var _browser = require("../utils/browser");
const useHasMounted = () => {
  const _useToggler = (0, _cdsCommon.useToggler)(false),
    hasMounted = _useToggler[0],
    toggleHasMounted = _useToggler[1];
  (0, _react.useEffect)(() => {
    toggleHasMounted.toggleOn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const componentShouldMount = (0, _react.useMemo)(() => hasMounted && (0, _browser.isBrowser)(), [hasMounted]);
  return componentShouldMount;
};
exports.useHasMounted = useHasMounted;